<template>
	<div class="flexcenter sort link" style="align-content: space-between;" :title="this.property">
		<span style="flex-grow:1;"> {{ this.label }}</span>
		<img src="@/assets/sort_asc.png" v-if="!this.tableConfig.desc && this.tableConfig.sort == this.property" />
		<img src="@/assets/sort_desc.png" v-if="this.tableConfig.desc && this.tableConfig.sort == this.property" />
		<img src="@/assets/sort_none.png" v-if="this.tableConfig.sort != this.property" />
	</div>
</template>


<script>
// sorterbar header för tabellen skicka in col, desc och sort
// import HeaderSort from '@/components/HeaderSort.vue'
// <HeaderSort :property='col.property' :label='col.label' :desc='this.desc' :sort='this.sort' />
export default {
	name: "HeaderSort",

	props: {
		property: String,
		label: String,
		//desc: Boolean,
		//sort: String
		tableConfig: Object
	},
	computed: {}
};
</script>





<style scoped>
div img {
	width: 10px;
	margin-left: 5px;
}
</style>
